/* =====================================================================
   HASHTACK · HX upgrade · behaviour (every page, deferred)
   Auto-swipe carousels, 3D hero, tabs, countdown, coupons, quick add,
   spend tracker, bundle, shop-the-look, count-up, reels, ribbon, menu.
   No libraries. Everything degrades to plain, readable HTML without JS.
   ===================================================================== */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  root.classList.add('hx-js');
  var REDUCED = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var DESIGN = !!(w.Shopify && w.Shopify.designMode);

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }
  function onVisible(el, cb, margin) {
    if (!('IntersectionObserver' in w)) { cb(true); return; }
    new IntersectionObserver(function (entries) { entries.forEach(function (e) { cb(e.isIntersecting); }); }, { rootMargin: margin || '0px' }).observe(el);
  }

  /* ---------- money ---------- */
  function formatMoney(paise) {
    var amount = (paise || 0) / 100;
    var fmt = (w.general && w.general.currency) || '₹{{amount_no_decimals}}';
    var noDec = Math.round(amount).toLocaleString('en-IN');
    var dec = amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount_no_decimals[a-z_]*\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dec)
      .replace(/\{\{\s*amount\s*\}\}/, (amount % 1 === 0) ? noDec : dec)
      .replace(/\.00(?!\d)/, '');
  }

  /* ---------- cart ---------- */
  function cartAddUrl() { return ((w.routes && w.routes.cart_add_url) || '/cart/add') + '.js'; }
  function alertError(msg) {
    try { w.dispatchEvent(new CustomEvent('showAlert', { detail: { message: msg, type: 'error' } })); } catch (e) {}
  }
  function hxAdd(items) {
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: 'side-cart' })
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) { alertError(res.data.description || res.data.message || 'Sorry, this could not be added to your bag.'); return false; }
        var drawer = w.general && w.general.enable_cart_drawer;
        if (drawer && w.ajaxCart && typeof w.ajaxCart.load === 'function' && res.data.sections && res.data.sections['side-cart']) {
          try { w.ajaxCart.load(res.data); } catch (e) { w.location.href = (w.routes && w.routes.cart_url) || '/cart'; }
        } else {
          w.location.href = (w.routes && w.routes.cart_url) || '/cart';
        }
        d.dispatchEvent(new CustomEvent('hx:cart'));
        return true;
      })
      .catch(function () { alertError('Sorry, something went wrong. Please try again.'); return false; });
  }
  function flash(btn, cls) { if (!btn) return; btn.classList.add(cls); setTimeout(function () { btn.classList.remove(cls); }, 1600); }
  d.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('.hx-add-form') : null;
    if (!f) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]'), btn = f.querySelector('button');
    if (!id || (btn && btn.classList.contains('is-busy'))) return;
    if (btn) btn.classList.add('is-busy');
    hxAdd([{ id: parseInt(id.value, 10), quantity: 1 }]).then(function (ok) {
      if (btn) { btn.classList.remove('is-busy'); if (ok) flash(btn, 'is-done'); }
    });
  });

  /* ---------- reveal ---------- */
  function initReveal(ctx) {
    var els = $$('.hx-reveal:not(.is-in)', ctx);
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in w)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, group = el.closest('ul, .hx-bento, .hx-gift__grid, .hx-story__grid, .hx-wrap');
        var i = Math.max(0, group ? $$('.hx-reveal', group).indexOf(el) : 0);
        el.style.setProperty('--hx-d', Math.min(i, 6) * 0.08 + 's');
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < w.innerHeight) el.classList.add('is-in'); }); }, 2500);
  }

  /* ---------- tilt (desktop) ---------- */
  function initTilt(ctx) {
    if (!FINE || REDUCED) return;
    $$('.hx-tilt', ctx).forEach(function (el) {
      if (!once(el, 'hxTilt')) return;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--hx-ry', (x * 12).toFixed(2) + 'deg');
        el.style.setProperty('--hx-rx', (-y * 9).toFixed(2) + 'deg');
        el.style.setProperty('--hx-ty', '-8px');
        el.style.setProperty('--hx-shine', ((x + 0.5) * 220 - 120).toFixed(0) + '%');
      });
      el.addEventListener('pointerleave', function () {
        ['--hx-ry', '--hx-rx', '--hx-ty'].forEach(function (p) { el.style.removeProperty(p); });
        el.style.setProperty('--hx-shine', '130%');
        setTimeout(function () { el.style.removeProperty('--hx-shine'); }, 800);
      });
    });
  }

  /* ---------- carousel (native scroll + auto-swipe) ---------- */
  function Carousel(el) {
    var track = el.querySelector('.hx-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;
    var mode = el.dataset.mode || '', center = el.hasAttribute('data-center');
    var interval = parseInt(el.dataset.interval, 10) || 4000;
    var dotsBox = el.querySelector('[data-hx-dots]'), dots = [];
    var paused = false, visible = false, timer = null, resumeT = null, active = -1, raf = null;
    if (getComputedStyle(track).position === 'static') track.style.position = 'relative';

    function overflow() { return track.scrollWidth > track.clientWidth + 4; }
    function slideCenter(s) { return s.offsetLeft + s.offsetWidth / 2; }
    function current() {
      var best = 0, bestD = Infinity, ref = center ? track.scrollLeft + track.clientWidth / 2 : track.scrollLeft;
      slides.forEach(function (s, i) {
        var pos = center ? slideCenter(s) : s.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
        var dist = Math.abs(pos - ref);
        if (dist < bestD) { bestD = dist; best = i; }
      });
      return best;
    }
    function targetLeft(i) {
      var s = slides[i];
      return center ? slideCenter(s) - track.clientWidth / 2 : s.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
    }
    function goTo(i, instant) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: Math.max(0, targetLeft(i)), behavior: instant || REDUCED ? 'auto' : 'smooth' });
    }
    function next(dir) {
      if (!overflow()) return;
      var i = current() + (dir || 1);
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 6;
      if ((dir || 1) > 0 && (i >= slides.length || (!center && atEnd))) i = 0;
      if (i < 0) i = slides.length - 1;
      goTo(i);
    }
    function paint() {
      raf = null;
      var i = current();
      if (i !== active) {
        active = i;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (b, k) { b.classList.toggle('on', k === i); });
        el.dispatchEvent(new CustomEvent('hx:active', { detail: { index: i } }));
      }
      if (mode && !REDUCED) {
        var mid = track.scrollLeft + track.clientWidth / 2;
        slides.forEach(function (s) {
          var dist = (slideCenter(s) - mid) / (s.offsetWidth || 1), a = Math.min(Math.abs(dist), 2.5);
          if (mode === 'coverflow') {
            s.style.transform = 'translateZ(' + (-a * 140).toFixed(1) + 'px) rotateY(' + (-Math.max(-2.2, Math.min(2.2, dist)) * 38).toFixed(1) + 'deg) scale(' + (1 - Math.min(a, 2) * 0.06).toFixed(3) + ')';
            s.style.zIndex = String(100 - Math.round(a * 10));
            s.style.opacity = a > 2.3 ? '0.35' : '1';
          } else {
            s.style.transform = 'rotateY(' + (-Math.max(-1, Math.min(1, dist)) * 10).toFixed(1) + 'deg) scale(' + (1 - Math.min(a, 1) * 0.08).toFixed(3) + ')';
            s.style.opacity = (1 - Math.min(a, 1) * 0.3).toFixed(2);
          }
        });
      }
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(paint); }
    function tick() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!paused && visible && !d.hidden && !REDUCED && overflow()) next(1);
        tick();
      }, interval);
    }
    function pause() { paused = true; clearTimeout(resumeT); }
    function resume(delay) { clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, delay == null ? 3000 : delay); }

    if (dotsBox && slides.length > 1 && slides.length <= 14) {
      dotsBox.innerHTML = '';
      slides.forEach(function (s, i) {
        var b = d.createElement('button');
        b.type = 'button'; b.tabIndex = -1; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { pause(); goTo(i); resume(); });
        dotsBox.appendChild(b); dots.push(b);
      });
    }
    $$('[data-hx-prev]', el).forEach(function (b) { b.addEventListener('click', function () { pause(); next(-1); resume(); }); });
    $$('[data-hx-next]', el).forEach(function (b) { b.addEventListener('click', function () { pause(); next(1); resume(); }); });
    track.addEventListener('scroll', schedule, { passive: true });
    w.addEventListener('resize', schedule);
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pause(); });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') resume(600); });
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', function () { resume(); }, { passive: true });
    el.addEventListener('focusin', pause);
    el.addEventListener('focusout', function () { resume(); });
    el.addEventListener('hx:refresh', function () { active = -1; schedule(); });
    // sections below the screen are not laid out yet (content-visibility), so the start slide
    // and the 3D positions are applied when the carousel first comes into view
    var start = parseInt(el.dataset.start, 10), started = false;
    onVisible(el, function (v) {
      visible = v;
      if (!v) return;
      if (!started) { started = true; if (!isNaN(start) && start > 0 && start < slides.length) requestAnimationFrame(function () { goTo(start, true); schedule(); }); }
      schedule();
    }, '200px');
    schedule();
    tick();
    el.hxCarousel = { goTo: goTo, next: next, refresh: schedule };
  }
  function initCarousels(ctx) { $$('[data-hx-carousel]', ctx).forEach(function (el) { if (once(el, 'hxCar')) Carousel(el); }); }

  /* ---------- 3D hero ---------- */
  function initHero(ctx) {
    $$('[data-hx-hero]', ctx).forEach(function (hero) {
      if (!once(hero, 'hxHero')) return;
      var stage = hero.querySelector('[data-hx-stage]'); if (!stage) return;
      var cards = $$('[data-hx-card]', stage), n = cards.length;
      var dots = $$('.hx-hero__dots i', hero);
      var speed = (parseInt(hero.dataset.speed, 10) || 4) * 1000, paused = false, visible = true, timer = null, resumeT = null;
      function sync() {
        cards.forEach(function (c, i) { if (dots[i]) dots[i].classList.toggle('on', c.dataset.pos === '0'); });
      }
      function rotate(dir) {
        if (n < 2) return;
        cards.forEach(function (c) { c.dataset.pos = String(((parseInt(c.dataset.pos, 10) || 0) + dir + n) % n); });
        sync();
      }
      function loop() { clearTimeout(timer); timer = setTimeout(function () { if (!paused && visible && !d.hidden && !REDUCED) rotate(1); loop(); }, speed); }
      function hold() { paused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, 4000); }
      cards.forEach(function (c) {
        c.addEventListener('click', function (e) {
          var pos = parseInt(c.dataset.pos, 10) || 0;
          if (pos !== 0) { e.preventDefault(); hold(); rotate(pos === 1 ? -1 : 1); }
        });
      });
      var sx = null;
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; });
      stage.addEventListener('pointerup', function (e) {
        if (sx == null) return; var dx = e.clientX - sx; sx = null;
        if (Math.abs(dx) > 40) { hold(); rotate(dx < 0 ? 1 : -1); }
      });
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) { hold(); rotate(dx < 0 ? 1 : -1); }
      }, { passive: true });
      if (FINE && !REDUCED) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          stage.style.setProperty('--hx-py', (x * 6).toFixed(2) + 'deg');
          stage.style.setProperty('--hx-px', (-y * 4).toFixed(2) + 'deg');
        });
        hero.addEventListener('pointerleave', function () { stage.style.removeProperty('--hx-py'); stage.style.removeProperty('--hx-px'); });
        stage.addEventListener('pointerenter', function () { paused = true; });
        stage.addEventListener('pointerleave', function () { paused = false; });
      }
      onVisible(hero, function (v) { visible = v; });
      sync(); loop();
    });
  }

  /* ---------- tabs ---------- */
  function initTabs(ctx) {
    $$('[data-hx-tabs]', ctx).forEach(function (box) {
      if (!once(box, 'hxTabs')) return;
      var mine = function (el) { return el.closest('[data-hx-tabs]') === box; };
      var btns = $$('[data-hx-tab]', box).filter(mine), panels = $$('[data-hx-panel]', box).filter(mine), stages = $$('[data-hx-stage]', box).filter(mine);
      var cur = 0, auto = parseInt(box.dataset.hxAuto, 10) || 0, paused = false, visible = false, resumeT = null;
      function show(i) {
        cur = i;
        btns.forEach(function (x) { var on = x.dataset.hxTab === String(i); x.classList.toggle('on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) {
          var on = p.dataset.hxPanel === String(i); p.hidden = !on;
          if (on) $$('[data-hx-carousel]', p).forEach(function (c) { var t = c.querySelector('.hx-track'); if (t) t.scrollLeft = 0; c.dispatchEvent(new CustomEvent('hx:refresh')); });
        });
        stages.forEach(function (st) { st.classList.toggle('on', st.dataset.hxStage === String(i)); });
      }
      function hold(ms) { paused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, ms); }
      btns.forEach(function (b) { b.addEventListener('click', function () { if (auto) hold(12000); show(parseInt(b.dataset.hxTab, 10)); }); });
      if (auto && btns.length > 1 && !REDUCED) {
        onVisible(box, function (v) { visible = v; });
        box.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { paused = true; clearTimeout(resumeT); } });
        box.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold(1500); });
        box.addEventListener('touchstart', function () { hold(8000); }, { passive: true });
        setInterval(function () { if (!paused && visible && !d.hidden) show((cur + 1) % btns.length); }, Math.max(3000, auto));
      }
    });
  }

  /* ---------- countdown ---------- */
  function initFlash(ctx) {
    $$('[data-hx-flash]', ctx).forEach(function (sec) {
      if (!once(sec, 'hxFlash')) return;
      var timer = sec.querySelector('[data-hx-timer]'), ended = sec.querySelector('[data-hx-ended]');
      if (!timer) return;
      var weekly = sec.dataset.mode === 'weekly', deals = $$('[data-hx-deal]', sec), maxEls = $$('[data-hx-max]', sec), end, iv;
      var WEEK = 7 * 864e5;
      function tzMin(v) {
        var m = /^([+-])(\d{1,2}):?(\d{2})$/.exec(String(v || '+05:30').trim());
        return m ? (m[1] === '-' ? -1 : 1) * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10)) : 330;
      }
      // next <weekday> <HH:MM>:59 in the shop's timezone, as a real timestamp
      function weekEnd(now) {
        var off = tzMin(sec.dataset.tz) * 6e4, day = parseInt(sec.dataset.day, 10) || 0, hm = (sec.dataset.time || '23:59').split(':');
        var wall = new Date(now + off), h = parseInt(hm[0], 10), m = parseInt(hm[1], 10);
        var e = Date.UTC(wall.getUTCFullYear(), wall.getUTCMonth(), wall.getUTCDate(), isNaN(h) ? 23 : h, isNaN(m) ? 59 : m, 59);
        e += ((day - wall.getUTCDay() + 7) % 7) * 864e5;
        if (e <= wall.getTime()) e += WEEK;
        return e - off;
      }
      // this week's 3 deals, taken in turn from the list (same for every visitor)
      function pick() {
        var n = deals.length;
        if (!n) return;
        var week = Math.floor((end - Date.UTC(2026, 0, 4)) / WEEK), start = ((week * 3) % n + n) % n, max = 0;
        deals.forEach(function (a) { a.hidden = true; });
        for (var k = 0; k < Math.min(3, n); k++) {
          var a = deals[(start + k) % n];
          a.hidden = false;
          a.className = a.className.replace(/hx-flash__pic--\d/, 'hx-flash__pic--' + (k + 1));
          max = Math.max(max, parseInt(a.dataset.off, 10) || 0);
        }
        if (max) maxEls.forEach(function (el) { el.textContent = max; });
      }
      if (weekly) { end = weekEnd(Date.now()); pick(); }
      else {
        end = Date.parse(sec.dataset.end || '');
        if (isNaN(end)) { timer.hidden = true; return; }
      }
      var units = { d: timer.querySelector('[data-u="d"]'), h: timer.querySelector('[data-u="h"]'), m: timer.querySelector('[data-u="m"]'), s: timer.querySelector('[data-u="s"]') };
      function pad(v) { return (v < 10 ? '0' : '') + v; }
      function tick() {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (left === 0 && weekly) { end = weekEnd(Date.now() + 1000); pick(); left = Math.max(0, Math.floor((end - Date.now()) / 1000)); }
        units.d.textContent = pad(Math.floor(left / 86400));
        units.h.textContent = pad(Math.floor(left % 86400 / 3600));
        units.m.textContent = pad(Math.floor(left % 3600 / 60));
        units.s.textContent = pad(left % 60);
        if (left === 0 && !weekly) {
          clearInterval(iv);
          if (sec.dataset.hide === 'true' && !DESIGN) { var wrap = sec.closest('.shopify-section') || sec; wrap.style.display = 'none'; }
          else { timer.hidden = true; if (ended) ended.hidden = false; }
        }
      }
      iv = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- coupons ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-hx-copy]') : null;
    if (!b) return;
    var code = b.dataset.hxCopy, label = b.textContent;
    function done() { b.textContent = b.dataset.done || 'Copied'; b.classList.add('ok'); setTimeout(function () { b.textContent = label; b.classList.remove('ok'); }, 2500); }
    function fallback() {
      var el = b.parentElement.querySelector('.hx-code__c');
      try { var r = d.createRange(); r.selectNodeContents(el); var s = w.getSelection(); s.removeAllRanges(); s.addRange(r); d.execCommand('copy'); done(); } catch (err) {}
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback); else fallback();
  });

  /* ---------- spend-more tracker ---------- */
  var tierEls = [];
  function paintTier(el, total, count) {
    var max = parseFloat(el.dataset.max) || 1, rs = total / 100;
    var track = el.querySelector('.hx-tier__track'), you = el.querySelector('[data-hx-tier-you]'), msg = el.querySelector('[data-hx-tier-msg]');
    var pct = Math.min(100, rs / max * 100);
    if (track) track.style.setProperty('--hx-fill', pct.toFixed(1) + '%');
    if (you) { you.hidden = count === 0; you.style.left = pct.toFixed(1) + '%'; you.textContent = (el.dataset.you || 'Your bag') + ' ' + formatMoney(total); }
    var nextMs = null;
    $$('.hx-ms', el).forEach(function (ms) {
      var amt = parseFloat(ms.dataset.amount) || 0;
      ms.classList.remove('is-done', 'is-next', 'is-locked');
      if (rs >= amt) ms.classList.add('is-done');
      else if (!nextMs) { nextMs = ms; ms.classList.add('is-next'); }
      else ms.classList.add('is-locked');
    });
    if (!msg) return;
    if (count === 0) msg.textContent = el.dataset.msgEmpty || '';
    else if (!nextMs) msg.textContent = el.dataset.msgDone || '';
    else {
      var gap = formatMoney(Math.round(((parseFloat(nextMs.dataset.amount) || 0) - rs) * 100));
      msg.textContent = (el.dataset.msgAway || '').replace('[gap]', gap).replace('[label]', nextMs.dataset.label || '');
    }
  }
  function refreshTiers() {
    if (!tierEls.length) return;
    fetch(((w.routes && w.routes.cart_url) || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { tierEls.forEach(function (el) { paintTier(el, c.total_price, c.item_count); }); })
      .catch(function () {});
  }
  function initTiers(ctx) {
    $$('[data-hx-tier]', ctx).forEach(function (el) { if (once(el, 'hxTier')) tierEls.push(el); });
    if (tierEls.length) refreshTiers();
  }
  d.addEventListener('hx:cart', function () { setTimeout(refreshTiers, 300); });
  w.addEventListener('themeCartOpened', function () { setTimeout(refreshTiers, 300); });
  d.addEventListener('visibilitychange', function () { if (!d.hidden) refreshTiers(); });
  function watchCartCount() {
    var cc = d.getElementById('cart-count');
    if (cc && 'MutationObserver' in w) new MutationObserver(function () { refreshTiers(); }).observe(cc, { childList: true, characterData: true, subtree: true });
  }

  /* ---------- bundle ---------- */
  function initBundles(ctx) {
    $$('[data-hx-bundle]', ctx).forEach(function (el) {
      if (!once(el, 'hxBundle')) return;
      // set = ready-made stack at its own prices (pre-selected); pick = any N for a fixed price
      var setMode = el.dataset.mode === 'set';
      var size = parseInt(el.dataset.size, 10) || 3, price = parseFloat(el.dataset.price) || 0;
      var picks = $$('[data-hx-pick]', el), slots = $$('[data-hx-slot]', el), chosen = [];
      var prog = el.querySelector('[data-hx-bprog]'), bar = el.querySelector('[data-hx-bbar]'), total = el.querySelector('[data-hx-total]');
      var worth = el.querySelector('[data-hx-worth]'), save = el.querySelector('[data-hx-save]'), add = el.querySelector('[data-hx-bundle-add]'), label = el.querySelector('[data-hx-blabel]');
      function item(p) { return { btn: p, id: parseInt(p.dataset.id, 10), price: parseFloat(p.dataset.price) || 0, cmp: parseFloat(p.dataset.cmp) || parseFloat(p.dataset.price) || 0, img: p.dataset.img }; }
      function paint() {
        slots.forEach(function (s, i) {
          var c = chosen[i], img = s.querySelector('img');
          s.classList.toggle('filled', !!c);
          if (c && !img) { img = d.createElement('img'); img.alt = ''; img.width = 92; img.height = 92; s.appendChild(img); }
          if (img) { if (c) img.src = c.img; else img.remove(); }
        });
        picks.forEach(function (p) { p.setAttribute('aria-pressed', chosen.some(function (c) { return c.btn === p; }) ? 'true' : 'false'); });
        var left = size - chosen.length, sum = chosen.reduce(function (a, c) { return a + c.price; }, 0), cmpSum = chosen.reduce(function (a, c) { return a + c.cmp; }, 0);
        if (prog) { prog.textContent = left > 0 ? (prog.dataset.tplPick || '').replace('[n]', left) : (prog.dataset.tplReady || ''); prog.classList.toggle('is-ready', left === 0); }
        if (bar) bar.style.width = (chosen.length / size * 100) + '%';
        if (setMode) {
          if (total) total.textContent = formatMoney(sum);
          if (worth) { worth.hidden = cmpSum <= sum; worth.textContent = formatMoney(cmpSum); }
          if (save) { save.hidden = cmpSum <= sum; save.textContent = 'You save ' + formatMoney(cmpSum - sum); }
          if (add) add.disabled = chosen.length === 0;
        } else {
          if (worth) { worth.hidden = left > 0; worth.textContent = formatMoney(sum); }
          if (save) { var sv = sum - price * 100; save.hidden = left > 0 || sv <= 0; save.textContent = 'You save ' + formatMoney(sv); }
          if (add) add.disabled = left > 0;
        }
        if (label && label.dataset.tpl) label.textContent = label.dataset.tpl.replace('[n]', chosen.length || size);
      }
      picks.forEach(function (p) {
        p.addEventListener('click', function () {
          var idx = -1; chosen.forEach(function (c, i) { if (c.btn === p) idx = i; });
          if (idx > -1) chosen.splice(idx, 1);
          else if (chosen.length < size) chosen.push(item(p));
          paint();
        });
      });
      if (add) add.addEventListener('click', function () {
        if (setMode ? !chosen.length : chosen.length < size) return;
        add.disabled = true;
        hxAdd(chosen.map(function (c) { return { id: c.id, quantity: 1 }; })).then(function (ok) {
          add.disabled = false;
          if (ok && !setMode) { chosen = []; paint(); }
          if (ok && setMode) flash(add, 'is-done');
        });
      });
      if (setMode) chosen = picks.filter(function (p) { return !p.disabled; }).slice(0, size).map(item);
      paint();
    });
  }

  /* ---------- shop the look ---------- */
  function initLooks(ctx) {
    $$('[data-hx-look]', ctx).forEach(function (el) {
      if (!once(el, 'hxLook')) return;
      var spots = $$('[data-hx-spot]', el), pops = $$('[data-hx-pop]', el), items = $$('[data-hx-item]', el);
      var cur = 0, paused = false, visible = false, resumeT = null;
      function show(i) {
        cur = i;
        spots.forEach(function (s) { s.classList.toggle('on', s.dataset.hxSpot === String(i)); });
        pops.forEach(function (p) { p.classList.toggle('on', p.dataset.hxPop === String(i)); });
        items.forEach(function (it) { it.classList.toggle('on', it.dataset.hxItem === String(i)); });
      }
      spots.forEach(function (s) {
        s.addEventListener('click', function () { paused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, 6000); show(parseInt(s.dataset.hxSpot, 10)); });
      });
      onVisible(el, function (v) { visible = v; });
      if (spots.length > 1 && !REDUCED) setInterval(function () { if (!paused && visible && !d.hidden) show((cur + 1) % spots.length); }, 3000);
      var all = el.querySelector('[data-hx-add-all]');
      if (all) all.addEventListener('click', function () {
        var list = items.filter(function (it) { return it.dataset.available === 'true'; }).map(function (it) { return { id: parseInt(it.dataset.id, 10), quantity: 1 }; });
        if (!list.length) return;
        all.disabled = true;
        hxAdd(list).then(function () { all.disabled = false; });
      });
      show(0);
    });
  }

  /* ---------- stack effect (before / after) ---------- */
  function initCompare(ctx) {
    $$('[data-hx-compare]', ctx).forEach(function (st) {
      if (!once(st, 'hxCmp')) return;
      var knob = st.querySelector('.hx-cmp__knob'), start = parseFloat(st.dataset.start) || 50, mode = st.dataset.auto || 'loop';
      var pos = start, drag = null, visible = false, hover = false, lastUser = 0, raf = null, waitT = null, running = false, step = 0;
      function set(p) {
        pos = Math.max(0, Math.min(100, p));
        st.style.setProperty('--pos', pos.toFixed(2) + '%');
        st.style.setProperty('--p', pos.toFixed(2));
        if (knob) knob.setAttribute('aria-valuenow', Math.round(pos));
      }
      function stop() { if (raf) cancelAnimationFrame(raf); raf = null; }
      function tween(to, ms, done) {
        stop();
        var from = pos, t0 = null;
        function frame(ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / ms), e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
          set(from + (to - from) * e);
          if (k < 1) raf = requestAnimationFrame(frame); else { raf = null; if (done) done(); }
        }
        raf = requestAnimationFrame(frame);
      }
      function user() { lastUser = Date.now(); stop(); clearTimeout(waitT); running = false; st.classList.add('is-touched'); }
      // intro sweep, then (loop mode) a gentle back-and-forth that pauses on touch, hover and off-screen
      var intro = [[82, 900, 250], [18, 1500, 250], [start, 1000, 2600]];
      var loop = [[26, 1500, 1300], [74, 2100, 1300], [start, 1500, 3200]];
      function canRun() { return visible && !hover && !drag && !d.hidden && Date.now() - lastUser > 5000; }
      function run() {
        clearTimeout(waitT);
        var seq = step < intro.length ? intro : loop;
        if (step >= intro.length && mode !== 'loop') { running = false; return; }
        if (!canRun()) { running = false; if (visible) waitT = setTimeout(kick, 900); return; }
        running = true;
        var s = seq[step < intro.length ? step : (step - intro.length) % loop.length];
        tween(s[0], s[1], function () { step++; waitT = setTimeout(run, s[2]); });
      }
      function kick() { if (!running) run(); }
      if (!REDUCED && mode !== 'off') onVisible(st, function (v) { visible = v; if (v) kick(); }, '0px 0px -15% 0px');

      function moveTo(x) { var r = st.getBoundingClientRect(); if (r.width) set((x - r.left) / r.width * 100); }
      st.addEventListener('pointerdown', function (e) {
        if (e.button) return;
        user();
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, on: e.pointerType === 'mouse' };
        if (drag.on) { e.preventDefault(); try { st.setPointerCapture(e.pointerId); } catch (er) {} st.classList.add('is-drag'); moveTo(e.clientX); }
      });
      st.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        if (!drag.on) {
          var dx = Math.abs(e.clientX - drag.x), dy = Math.abs(e.clientY - drag.y);
          if (dx > 6 && dx > dy) { drag.on = true; st.classList.add('is-drag'); try { st.setPointerCapture(e.pointerId); } catch (er) {} }
          else if (dy > 10) { drag = null; return; }
        }
        if (drag.on) { lastUser = Date.now(); moveTo(e.clientX); }
      });
      function end(e) {
        if (!drag || e.pointerId !== drag.id) return;
        if (!drag.on && e.type === 'pointerup') { var r = st.getBoundingClientRect(); tween((e.clientX - r.left) / r.width * 100, 450); }
        drag = null; lastUser = Date.now(); st.classList.remove('is-drag');
        waitT = setTimeout(kick, 5200);
      }
      st.addEventListener('pointerup', end);
      st.addEventListener('pointercancel', end);
      st.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
      st.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; waitT = setTimeout(kick, 1500); } });
      if (knob) knob.addEventListener('keydown', function (e) {
        var k = e.key, to = null;
        if (k === 'ArrowLeft' || k === 'ArrowDown') to = pos - 5;
        else if (k === 'ArrowRight' || k === 'ArrowUp') to = pos + 5;
        else if (k === 'Home') to = 0;
        else if (k === 'End') to = 100;
        if (to === null) return;
        e.preventDefault(); user(); set(to);
      });
      set(start);
    });
  }

  /* ---------- new launch (fanned stack + swatches) ---------- */
  function initLaunch(ctx) {
    $$('[data-hx-launch]', ctx).forEach(function (el) {
      if (!once(el, 'hxLaunch')) return;
      var cards = $$('[data-hx-ls]', el), sws = $$('[data-hx-sw]', el), n = cards.length;
      if (!n) return;
      var name = el.querySelector('[data-hx-lname]'), price = el.querySelector('[data-hx-lprice]'), cmp = el.querySelector('[data-hx-lcmp]'), view = el.querySelector('[data-hx-lview]');
      var cur = 0, paused = false, visible = false, resumeT = null, interval = Math.max(2000, parseInt(el.dataset.interval, 10) || 3000);
      function show(i) {
        cur = (i + n) % n;
        cards.forEach(function (c, k) {
          var dist = (k - cur + n) % n;
          c.classList.remove('is-front', 'is-next', 'is-prev', 'is-back');
          c.classList.add(dist === 0 ? 'is-front' : dist === 1 ? 'is-next' : (dist === n - 1 && n > 2) ? 'is-prev' : 'is-back');
          c.tabIndex = dist === 0 ? 0 : -1;
        });
        sws.forEach(function (b, k) { var on = k === cur; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        var c = cards[cur];
        if (name) { name.textContent = c.dataset.title; name.href = c.getAttribute('href'); }
        if (price) price.textContent = c.dataset.price;
        if (cmp) { cmp.textContent = c.dataset.cmp || ''; cmp.hidden = !c.dataset.cmp; }
        if (view) view.href = c.getAttribute('href');
      }
      function hold(ms) { paused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, ms); }
      sws.forEach(function (b, k) { b.addEventListener('click', function () { hold(8000); show(k); }); });
      el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { paused = true; clearTimeout(resumeT); } });
      el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold(800); });
      var stage = el.querySelector('.hx-launch__stage'), sx = null;
      if (stage) {
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; hold(6000); }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx; sx = null;
          if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
      onVisible(el, function (v) { visible = v; });
      if (n > 1 && !REDUCED) setInterval(function () { if (!paused && visible && !d.hidden) show(cur + 1); }, interval);
    });
  }

  /* ---------- count-up ---------- */
  function initCounts(ctx) {
    if (REDUCED) return;
    $$('[data-hx-count]', ctx).forEach(function (el) {
      if (!once(el, 'hxCount')) return;
      var txt = el.textContent, m = txt.match(/(\d[\d,]*)(\.\d+)?/);
      if (!m) return;
      var decimals = m[2] ? m[2].length - 1 : 0, target = parseFloat((m[1] + (m[2] || '')).replace(/,/g, ''));
      var pre = txt.slice(0, m.index), post = txt.slice(m.index + m[0].length), done = false;
      onVisible(el, function (v) {
        if (!v || done) return; done = true;
        var t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / 1400), e = 1 - Math.pow(1 - p, 3), val = target * e;
          el.textContent = pre + (decimals ? val.toFixed(decimals) : Math.round(val).toLocaleString('en-IN')) + post;
          if (p < 1) requestAnimationFrame(step); else el.textContent = txt;
        }
        requestAnimationFrame(step);
      });
    });
  }

  /* ---------- reels ---------- */
  function initReels(ctx) {
    $$('[data-hx-reels]', ctx).forEach(function (sec) {
      if (!once(sec, 'hxReels')) return;
      var car = sec.querySelector('[data-hx-carousel]'), vids = $$('video', sec), loaded = false, visible = false, activeI = 0;
      function load() { if (loaded) return; loaded = true; vids.forEach(function (v) { if (v.dataset.src && !v.src) v.src = v.dataset.src; }); }
      function play() {
        vids.forEach(function (v, i) {
          var slide = v.closest('.hx-slide'), idx = slide ? Array.prototype.indexOf.call(slide.parentElement.children, slide) : i;
          if (visible && idx === activeI && !REDUCED) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { try { v.pause(); } catch (e) {} }
        });
      }
      onVisible(sec, function (v) { if (v) load(); }, '400px');
      onVisible(sec, function (v) { visible = v; play(); });
      if (car) car.addEventListener('hx:active', function (e) { activeI = e.detail.index; play(); });
    });
  }

  /* ---------- marquee touch pause ---------- */
  function initMarquee(ctx) {
    $$('.hx-marquee', ctx).forEach(function (m) {
      if (!once(m, 'hxMarq')) return;
      m.addEventListener('touchstart', function () { m.classList.add('is-paused'); }, { passive: true });
      m.addEventListener('touchend', function () { setTimeout(function () { m.classList.remove('is-paused'); }, 1500); }, { passive: true });
    });
  }

  /* ---------- discount ribbon ---------- */
  function initRibbon(ctx) {
    $$('[data-hx-ribbon]', ctx).forEach(function (rb) {
      if (!once(rb, 'hxRibbon')) return;
      try { if (!DESIGN && rb.dataset.dismiss === 'true' && w.sessionStorage.getItem('hxRibbonClosed') === '1') { rb.classList.add('is-closed'); return; } } catch (e) {}
      var items = $$('.hx-ribbon__i', rb), cur = 0, paused = false, interval = parseInt(rb.dataset.interval, 10) || 4000;
      function show(i) {
        if (items.length < 2) return;
        i = (i + items.length) % items.length; if (i === cur) return;
        var old = items[cur]; old.classList.remove('on'); old.classList.add('out');
        setTimeout(function () { old.classList.remove('out'); }, 750);
        items[i].classList.add('on'); cur = i;
      }
      if (items.length > 1 && !REDUCED) setInterval(function () { if (!paused && !d.hidden) show(cur + 1); }, interval);
      rb.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') paused = true; });
      rb.addEventListener('pointerleave', function () { paused = false; });
      var p = rb.querySelector('[data-hx-rprev]'), n = rb.querySelector('[data-hx-rnext]'), x = rb.querySelector('[data-hx-rclose]');
      if (p) p.addEventListener('click', function () { show(cur - 1); });
      if (n) n.addEventListener('click', function () { show(cur + 1); });
      if (x) x.addEventListener('click', function () { rb.classList.add('is-closed'); try { w.sessionStorage.setItem('hxRibbonClosed', '1'); } catch (e) {} });
      var sx = null, sy = null;
      rb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; paused = true; }, { passive: true });
      rb.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 30 || Math.abs(dy) > 20) show(cur + ((dx < 0 || dy < 0) ? 1 : -1));
        setTimeout(function () { paused = false; }, 3000);
      }, { passive: true });
    });
  }

  /* ---------- menu upgrade (decorates the theme's #nav) ---------- */
  function initMenu() {
    var data = d.querySelector('[data-hx-menu]'), nav = d.getElementById('nav');
    if (!data || !nav) return;
    function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
    function titleOf(a) {
      if (!a.dataset.hxTitle) {
        var t = ''; a.childNodes.forEach(function (nd) { if (nd.nodeType === 3) t += nd.textContent; else if (nd.nodeType === 1 && !nd.classList.contains('hx-navtag') && nd.tagName !== 'IMG') t += nd.textContent; });
        a.dataset.hxTitle = norm(t);
      }
      return a.dataset.hxTitle;
    }
    function topLinks() { return $$('li > a:first-child', nav).filter(function (a) { var li = a.parentElement; return li && li.parentElement && !li.parentElement.closest('li') && !a.closest('.hx'); }); }
    var tags = $$('[data-hx-tag]', data).map(function (t) { return { item: norm(t.dataset.item), label: t.dataset.label, style: t.dataset.style }; });
    var thumbs = $$('[data-hx-thumb]', data).map(function (t) { return { item: norm(t.dataset.item), src: t.dataset.src }; });
    var descs = $$('[data-hx-desc]', data).map(function (t) { return { item: norm(t.dataset.item), text: t.dataset.text }; });
    var feats = $$('template[data-hx-feat]', data).map(function (t) { return { item: norm(t.dataset.item), tpl: t }; });
    var promo = data.dataset.promo || '';
    var topTpl = data.querySelector('template[data-hx-mx-top]'), botTpl = data.querySelector('template[data-hx-mx-bottom]');
    var busy = false;
    function decorate() {
      if (busy) return; busy = true;
      topLinks().forEach(function (a) {
        var t = titleOf(a), li = a.parentElement;
        tags.forEach(function (tg) {
          if (tg.item === t && !a.querySelector('.hx-navtag')) { var s = d.createElement('span'); s.className = 'hx-navtag' + (tg.style === 'maroon' ? ' hx-navtag--maroon' : ''); s.textContent = tg.label; a.appendChild(s); }
        });
        if (!a.querySelector('img')) thumbs.forEach(function (th) {
          if (th.item === t) { var im = d.createElement('img'); im.className = 'hx-thumb'; im.src = th.src; im.alt = ''; im.width = 36; im.height = 36; im.loading = 'lazy'; a.insertBefore(im, a.firstChild); }
        });
        if (li.classList.contains('sub') && !li.classList.contains('show-all')) {
          var ul = li.querySelector(':scope > ul');
          if (ul) {
            feats.forEach(function (f) { if (f.item === t && !ul.querySelector(':scope > .hx-mm-feat')) { ul.appendChild(f.tpl.content.cloneNode(true)); ul.classList.add('hx-mm-has-feat'); } });
            if (promo && !ul.querySelector(':scope > .hx-mm-bar')) { var bar = d.createElement('li'); bar.className = 'hx-mm-bar'; bar.textContent = promo; ul.appendChild(bar); ul.classList.add('hx-mm-ul'); }
          }
        }
      });
      if (descs.length) $$('li li > a', nav).forEach(function (a) {
        if (a.querySelector('.hx-mm-desc') || a.closest('.hx')) return;
        var t = titleOf(a);
        descs.forEach(function (ds) {
          if (ds.item !== t) return;
          // stack the link text and its description in one wrapper, next to the thumbnail
          var wrap = d.createElement('span'); wrap.className = 'hx-mm-txt';
          Array.prototype.slice.call(a.childNodes).forEach(function (nd) { if (nd.nodeType === 3 && nd.textContent.trim()) wrap.appendChild(nd); });
          var s = d.createElement('span'); s.className = 'hx-mm-desc'; s.textContent = ds.text; wrap.appendChild(s);
          a.appendChild(wrap);
        });
      });
      // Drawer extras live INSIDE the theme's first menu list (as first/last <li>):
      // the theme relies on "#nav > ul:first-child", so nothing may be placed before that list.
      var list = nav.querySelector(':scope > ul[data-type="main-nav"]') || nav.querySelector(':scope > ul');
      if (list) {
        if (topTpl && !list.querySelector(':scope > li.hx-drawer-top')) {
          var top = d.createElement('li'); top.className = 'hx hx-drawer-top'; top.appendChild(topTpl.content.cloneNode(true));
          list.insertBefore(top, list.firstChild);
        }
        if (botTpl) {
          var bot = list.querySelector(':scope > li.hx-drawer-bottom');
          if (!bot) { bot = d.createElement('li'); bot.className = 'hx hx-drawer-bottom'; bot.appendChild(botTpl.content.cloneNode(true)); }
          if (list.lastElementChild !== bot) list.appendChild(bot);
        }
      }
      busy = false;
    }
    decorate();
    if ('MutationObserver' in w) {
      var t = null;
      new MutationObserver(function () { if (busy) return; clearTimeout(t); t = setTimeout(decorate, 60); }).observe(nav, { childList: true, subtree: true });
    }
  }

  /* ---------- speed: pause CSS animations in sections that are off screen ---------- */
  function initOffscreen(ctx) {
    if (!('IntersectionObserver' in w)) return;
    var io = initOffscreen.io || (initOffscreen.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('hx-offscreen', !en.isIntersecting); });
    }, { rootMargin: '150px 0px' }));
    $$('section.hx, .hx-ribbon', ctx).forEach(function (el) { if (once(el, 'hxOff')) io.observe(el); });
  }

  /* ---------- boot ---------- */
  function initAll(ctx) {
    initReveal(ctx); initTilt(ctx); initCarousels(ctx); initHero(ctx); initTabs(ctx); initFlash(ctx);
    initTiers(ctx); initBundles(ctx); initLooks(ctx); initCompare(ctx); initLaunch(ctx); initCounts(ctx); initReels(ctx); initMarquee(ctx); initRibbon(ctx); initOffscreen(ctx);
  }
  function boot() { initAll(d); initMenu(); watchCartCount(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); if (e.target.querySelector && e.target.querySelector('[data-hx-menu]')) initMenu(); });
  d.addEventListener('shopify:block:select', function (e) {
    var car = e.target.closest ? e.target.closest('[data-hx-carousel]') : null;
    if (car && car.hxCarousel) { var slide = e.target.closest('.hx-slide'); if (slide) car.hxCarousel.goTo(Array.prototype.indexOf.call(slide.parentElement.children, slide), true); }
  });
})();
